// extracted by mini-css-extract-plugin
export default {"certificate":"certificate_certificate__jcudC","text":"certificate_text__FfatZ","btn":"certificate_btn__s8Gyf"};